import {apiBindings} from "../../utils/constants";

// One monochrome avatar layer, tinted the way the client tints at runtime:
// Image.color is a MULTIPLY, so white art takes the tint, black stays black,
// grays shade in between, and the PNG's alpha carries the shape.
//
// Reproduced here as: a container clipped to the art's alpha (CSS mask), holding
// a solid tint fill with the art multiplied on top. `isolation` keeps the
// multiply from blending with whatever is behind the component — essential when
// layers stack in the composite preview.
//
// The component is transparent outside the mask, so the CALLER must place it
// over a dark (or checkerboard) backing for light tints to read — per tile in
// the element grid, once behind the whole stack in the composite (a backing per
// layer would occlude the layers below it).
function TintedPreview(props: {fileName: string; color: string; size: number}) {
    const url = `${apiBindings.images}${props.fileName}`;
    const mask = `url(${url})`;
    return (
        <div style={{
            width: props.size, height: props.size,
            position: 'relative', isolation: 'isolate',
            maskImage: mask, WebkitMaskImage: mask,
            maskSize: 'contain', WebkitMaskSize: 'contain',
            maskRepeat: 'no-repeat', WebkitMaskRepeat: 'no-repeat',
            maskPosition: 'center', WebkitMaskPosition: 'center',
        }}>
            <div style={{position: 'absolute', inset: 0, backgroundColor: props.color}}/>
            <img src={url} alt="" draggable={false} style={{
                position: 'absolute', inset: 0,
                width: '100%', height: '100%', objectFit: 'contain',
                mixBlendMode: 'multiply',
            }}/>
        </div>
    );
}

export default TintedPreview;
